import React from 'react';
import Sidebar from '../sidebar/sidebar';
import MobileNav from '../mobilenav/mobilenav';


const Layout = () => {
    return (
        <>
         <MobileNav />
         <Sidebar />
        </>
    );
};

export default Layout;
